import axios from '@/libs/api.request';

export const getBankRecordList = data => {
    return axios.request({
        url: 'api/financeManagement/bankRecord/getBankRecordList',
        data: data,
        method: 'post'
    });
};

export const queryCMBPayState = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/CMBPay/QueryCMBPay',
        data: data,
        method: 'post'
    });
};


export const queryCCBCPayState = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/CCBCPay/QueryCCBCPay',
        data: data,
        method: 'post'
    });
};
